import { render, staticRenderFns } from "./statisticsLandord.vue?vue&type=template&id=374b760f&scoped=true&"
import script from "./statisticsLandord.vue?vue&type=script&lang=js&"
export * from "./statisticsLandord.vue?vue&type=script&lang=js&"
import style0 from "./statisticsLandord.vue?vue&type=style&index=0&id=374b760f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374b760f",
  null
  
)

export default component.exports